export default __webpack_public_path__ + "static/media/yellow_pawn.54add973.png";